<template>
  <section class="free-listing-promo">
    <div class="row">
      <div class="exclamation">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          stroke-linejoin="round"
          stroke-miterlimit="1.4"
          clip-rule="evenodd"
          viewBox="0 0 35 35"
        >
          <path
            id="exclaim-icon"
            d="M17.4.8a16.7 16.7 0 1 1 0 33.4 16.7 16.7 0 0 1 0-33.5zm-.6 27.5a2.7 2.7 0 0 1-1.4-2.2c0-1.6 1.6-2.9 3.2-2.4 1.1.3 1.8 1.3 1.8 2.4 0 1-.4 1.6-1.2 2-.6.5-1.7.5-2.4.2zm.2-6.4l-.5-.4c-.7-.6-.7-.6-1.1-7.6L15 7c.4-1 1.3-1.4 2.7-1.3.9 0 1.6.3 2 1 .4.4.5.7.5 1.5L19.7 20c-.1.8-.6 1.5-1.3 1.8-.4.2-1 .2-1.4 0z"
          />
        </svg>
      </div>
      <translate tag="h2">
        This site does not currently take bookings here on Pitchup.com.
      </translate>
    </div>

    <div class="box">
      <translate tag="p">
        If you are the owner of this site, start taking bookings through
        Pitchup.com. It's free, quick and easy!
      </translate>

      <a
        :href="`https://www.pitchup.com/${
          $i18n.locale !== 'en-gb' ? $i18n.locale + '/' : ''
        }join/`"
        target="_blank"
        class="button minimal square"
        ><img
          loading="lazy"
          class="icon"
          src="@/assets/images/pencil.svg"
          width="26"
          height="27"
          alt=""
        />
        <translate>Add your business details</translate>
      </a>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'
@Component
class CampsiteDetailFreeListingPromo extends Vue {}

export default toNative(CampsiteDetailFreeListingPromo)
</script>

<style scoped>
.free-listing-promo {
  background: var(--colour-pale-blue);
  margin: 1em 0 0;
  padding: 2em 1.4em 1.5em;
}

h2 {
  color: var(--colour-mid-blue);
  font-size: 1.25em;
}

.box {
  background: white;
  padding: 1em;
  margin: 1em 0;
  border-radius: 0.3em;
}

.exclamation {
  width: 3em;
  height: auto;
  margin-right: 1em;
  flex-shrink: 0;
}

#exclaim-icon {
  fill: var(--colour-blue);
}

.button {
  margin-top: 1em;
  color: var(--colour-mid-blue);
}
</style>
